import { render } from "./WhatsAppCoachingPage.vue?vue&type=template&id=653c8b98"
import script from "./WhatsAppCoachingPage.vue?vue&type=script&lang=js"
export * from "./WhatsAppCoachingPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__